import React, { useState } from "react";
import dashboardIcon from "../../../Assets/Images/Revenue-management/dashboardIcon.svg";
import rmcopilot from "../../../Assets/Images/RMCopilot/rmcopilot.svg";
import { Link, NavLink } from "react-router-dom";
import { commonService } from "../../../utils/commonService";

function AsideRmCopilot() {
  //   const [activeRoute, setActiveRoute] = useState("/");
  //   const userDetail = commonService.getLoginUserData();

  return (
    <aside className="revenue-management-aside-main asideConfigurationMain container-menu-bar">
      <ul className="list-unstyled p-0 m-0">
        <li>
          <NavLink
            to="/RmCopilot/rm-copilot-dashboard"
            className="revenue-aside-links"
          >
            <img src={dashboardIcon} alt="dashboard" />
            <span className="main-menu-text">Dashboard</span>
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/RmCopilot/rm-copilot"
            className="revenue-aside-links"
            target="_blank"
          >
            <img src={rmcopilot} alt="rm-colipot" />
            <span className="main-menu-text">Rm Copilot</span>
          </NavLink>
        </li>
      </ul>
    </aside>
  );
}

export default AsideRmCopilot;
